import type { ProvidedJobPost } from '../hooks/useProvidedJobPosts';
import { isSelected, type Selection } from '../hooks/useSelection';
import ProvidedJobPostCard from './ProvidedJobPostCard';

interface Props {
  providedJobPosts: ProvidedJobPost[];
  selection?: Selection;
  onCheckedChange?: (id: number, checked: boolean) => void;
  onDelete?: (id: number) => Promise<void> | void;
}

export default function Results({ providedJobPosts, selection, onCheckedChange, onDelete }: Props) {
  return (
    <div className="flex flex-col gap-lg">
      {providedJobPosts.map((p) => (
        <ProvidedJobPostCard
          key={p.id}
          {...p}
          isChecked={selection ? isSelected(selection, p.id) : false}
          onCheckedChange={(checked) => onCheckedChange?.(p.id, checked)}
          onDelete={onDelete ? () => onDelete(p.id) : undefined}
        />
      ))}
    </div>
  );
}
